// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

var Utils = {};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardRelayNavigation_formState",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidatorsKeyFacts_formState"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidatorsDescription_formState"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidatorsPhotosAndFiles_formState"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyWizardFormRelayValidatorsMLSTiming_formState"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepKeyFactsTouched",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepMlsTimingTouched",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepDescriptionTouched",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepShowingsTouched",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepPhotosAndFilesTouched",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
